import { render, staticRenderFns } from "./ruzhu.vue?vue&type=template&id=cd17d8f2&scoped=true&"
import script from "./ruzhu.vue?vue&type=script&lang=js&"
export * from "./ruzhu.vue?vue&type=script&lang=js&"
import style0 from "./ruzhu.vue?vue&type=style&index=0&id=cd17d8f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd17d8f2",
  null
  
)

export default component.exports